import React from 'react';
import Header from '../dashboard/header/header';
import Auth from '../../dashboard/user/auth';

const Layout = ({ children }) => {
    return (
        <>
            <Auth isHeader={true} />
            <div className='mb-24'>
                <Header />
            </div>
            <main className=''>{children}</main>
        </>
    )
}

export default Layout;